import { Ecommerce } from '@lifesize/types';

export interface EcommerceInterface {
  loading: boolean;
  account?: Ecommerce.Account;
}

export const initialState: EcommerceInterface = {
  loading: false
};

export default initialState;
